import { render, staticRenderFns } from "./SideNave.vue?vue&type=template&id=3491863d&scoped=true&"
import script from "./SideNave.vue?vue&type=script&lang=js&"
export * from "./SideNave.vue?vue&type=script&lang=js&"
import style0 from "./SideNave.vue?vue&type=style&index=0&id=3491863d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3491863d",
  null
  
)

export default component.exports